export enum HealthStatus {
  Degraded = 'Degraded',
  Healthy = 'Healthy',
  Unhealthy = 'Unhealthy'
}
